module.exports = __webpack_public_path__ + "static/media/check-done-dark.6ee2a52d.svg";